import { Component, Input, OnInit, inject } from '@angular/core';
import { MinimalProvider } from 'app/core/models/minimal-provider.model';
import { ProviderOffice } from '../../../core/models/provider-office.model';
import { ProviderOfficeFilters, ProviderService } from '../../../core/services/provider.service';

import { OfficeComponent } from '../office/office.component';

@Component({
    selector: 'app-prescriber-offices-scrollable',
    templateUrl: './prescriber-offices-scrollable.component.html',
    styleUrls: ['./prescriber-offices-scrollable.component.scss'],
    imports: [OfficeComponent]
})
export class PrescriberOfficesScrollableComponent implements OnInit {
  private providerService = inject(ProviderService);

  @Input() provider: MinimalProvider;
  @Input() acceptableFaxStatusOnly = false;

  officesRefreshing = true;
  providerOffices: ProviderOffice[] = [];
  providerOfficeFaxStatuses = {};

  ngOnInit() {
    this.loadOffices();
  }

  loadOffices() {
    this.officesRefreshing = true;

    const filters = new ProviderOfficeFilters();
    filters.acceptableFaxStatusOnly = this.acceptableFaxStatusOnly;

    this.providerService
      .getProviderOffices(this.provider.id, filters)
      .subscribe((providerOffices: ProviderOffice[]) => {
        this.providerOffices = providerOffices;

        this.officesRefreshing = false;
      });
  }
}
